// @ts-ignore
export const environment = globalThis.angularEnvironment;